import { Label } from "expano-components";
import { Button, MainList, Main } from "components";

import { ReactComponent as ShopIcon } from "icons/shop.svg";

import { sort, filters } from "./const/data";

const ShopsList = ({ history }) => (
  <Main
    page={{
      name: "Sklepy",
      icon: <ShopIcon />,
      breadcrumbs: [
        {
          name: "Sklepy",
        },
      ],
      buttons: <Button type="add" text="Dodaj sklep" path="/shops/new" />,
    }}
  >
    <MainList
      query_key="shops"
      api_path="/shops"
      sort_column="id"
      sort_direction="desc"
      context="ui_index"
      sort={sort}
      filters={filters}
      handleNavigate={(item) => history.push(`/shops/${item.id}`)}
      renderItem={({ id, name, label_text, label_color, platforms }) => (
        <>
          <td>{id}</td>
          <td>{name}</td>
          <td>
            <Label text={label_text} type="fill" color={label_color} />
          </td>
          <td>
            {platforms
              ?.sort((a, b) => a.id - b.id)
              ?.map(({ id, label_text, label_color }) => (
                <Label
                  key={id}
                  text={label_text}
                  type="bordered"
                  color={label_color}
                />
              ))}
          </td>
        </>
      )}
    />
  </Main>
);

export default ShopsList;
